<template>
  <div class="page_wrps">
    <div class="page_title">联系</div>
    <div class="page_set">合作加入</div>
    <div class="page_devs">
      <div class="paeg_flex">
        <div style="margin-right: 4rem;">
          <div class="page_name">您的姓名</div>
          <div class="paeg_ipu">
            <input
              type="text"
              v-model="from.userName"
              class="custom-input"
              placeholder="Your Name*"
            />
          </div>
        </div>
        <div>
          <div class="page_name">联系方式</div>
          <div class="paeg_ipu">
            <input
              type="text"
              v-model="from.userPhone"
              class="custom-input"
              placeholder="Contact Details*"
            />
          </div>
        </div>
      </div>
      <div>
        <div class="page_name">邮箱地址</div>
        <div class="paeg_ipu">
          <input type="text" v-model="from.userEmail" class="custom-input" placeholder="Email*" />
        </div>
      </div>
      <div class="flex_ve">
        <div>
          <div>
            <div class="page_name">公司名称</div>
            <div class="paeg_ipu">
              <input
                type="text"
                v-model="from.companyName"
                class="custom-input"
                placeholder="Company Name*"
              />
            </div>
          </div>
          <div>
            <div class="page_name">您有什么样的需求</div>
            <div class="paeg_ipu">
              <input
                type="text"
                v-model="from.needs"
                class="custom-input"
                placeholder="What Are Your Needs*"
              />
            </div>
          </div>
        </div>
        <div>
          <img class="page_image" src="../assets/code.png" />
        </div>
      </div>
      <div class="page_code_add">
        <div>
          <button class="page—btn" @click="pagereact">重置</button>
        </div>
        <div>
          <button class="page—btn2" @click="clickPage">提交</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postWebBusiness } from "@/api/api";
export default {
    data() {
        return {
            from: {},
            index: false
        };
    },
    methods: {
        pagereact() {
            this.from = {};
        },
        async clickPage() {
            if (!this.from.userName) {
                return this.$message({
                    message: "请输入姓名后,重新提交",
                    type: "error"
                });
            }
            if (!this.from.userPhone) {
                return this.$message({
                    message: "请输入联系方式后,重新提交",
                    type: "error"
                });
            }
            if (!this.from.userEmail) {
                return this.$message({
                    message: "请输入邮箱后,重新提交",
                    type: "error"
                });
            }
            let data = {
                ...this.from
            };
            try {
                if (this.index == false) {
                    this.index = true;
                    let res = await postWebBusiness(data);
                    if (res.code == 200) {
                        this.$message('提交成功,请耐心等候!');
                        this.from = {};
                        this.index = false;
                    }
                }
            } catch (e) {
                this.index = false;
            }
        }
    }
};
</script>

<style scoped>
.page_wrps {
    width: 100%;
    padding: 5rem;
    background: #131316;
    color: #fff;
}

.page_title {
    font-size: 4.25rem;
    color: #fff;
    font-family: PingFangSC, PingFang SC;
    font-style: normal;
    padding-bottom: 2.6rem;
    margin-top: 6.8rem;
    border-bottom: 0.2rem solid #caab62;
    display: inline-block;
}

.page_set {
    margin-top: 3.62rem;
    font-size: 3rem;
    color: #fff;
}

.paeg_ipu {
    width: 33.75rem;
    border-bottom: 0.1rem solid #d8d8d8;
}

.page_devs {
    width: 71.25rem;
    margin-left: 6.25rem;
}

.custom-input {
    width: 30rem;
    transform: translateX(-0.6rem);
    background-color: #131316;
    /* 背景设为黑色 */
    color: #cccccc;
    /* 字体颜色设为#CCCCCC */
    border: none;
    /* 移除边框 */
    outline: none;
    /* 移除焦点时的轮廓线 */
    padding: 0.625rem;
    /* 添加内边距以提升视觉效果 */
    font-size: 1.5rem;
    /* 设置字体大小 */
    /* 如果需要，还可以添加其他样式属性 */
}

/* 针对placeholder的伪元素样式设置 */
.custom-input::-webkit-input-placeholder {
    color: #cccccc;
    /* WebKit内核浏览器（如Chrome、Safari）的placeholder字体颜色 */
}

.custom-input::-moz-placeholder {
    color: #cccccc;
    /* Firefox浏览器的placeholder字体颜色 */
}

.custom-input:-ms-input-placeholder {
    color: #cccccc;
    /* Internet Explorer 10-11的placeholder字体颜色 */
}

.custom-input::-ms-input-placeholder {
    color: #cccccc;
    /* Microsoft Edge旧版的placeholder字体颜色 */
}

.custom-input::placeholder {
    color: #cccccc;
    /* 标准语法，适用于大多数现代浏览器 */
}

.page_name {
    font-size: 1.5rem;
    font-family: PingFangSC, PingFang SC;
    font-style: normal;
    font-weight: 400;
    margin-bottom: 1.3rem;
    margin-top: 2rem;
}

.paeg_flex {
    display: flex;
    align-items: center;
}

.flex_ve {
    display: flex;
    justify-content: space-between;
}

.page_image {
    width: 10.25rem;
    height: 10.25rem;
    object-fit: cover;
    margin-top: 6.2rem;
}

.page_code_add {
    display: flex;
    align-items: center;
    margin-top: 6rem;
}

.page—btn {
    border: none;
    color: #ffffff;
    background: #131316;
    border: 0.06rem solid rgba(255, 255, 255, 0.8);
    padding: 0.6rem 3.5rem;
    font-size: 1.5rem;
    border-radius: 2rem;
    margin-right: 1.75rem;
}

.page—btn2 {
    border: none;
    color: #ffffff;
    background: rgba(202, 171, 98, 1);
    border: 0.06rem solid rgba(202, 171, 98, 1);
    padding: 0.6rem 3.5rem;
    font-size: 1.5rem;
    border-radius: 2rem;
}
</style>